import {procedures} from '@mep/pae-commons';
import filter from 'lodash/filter';
import PropTypes from 'prop-types';
import React, {createContext, useContext, useMemo} from 'react';

import {useGetProcessSettings} from '@/modules/actors/hooks/processSettings';

import {fields} from '../../company/containers/ProcedureDetailContainer/constants/procedure.mep.fields';

const ProcessSettingsContext = createContext();

const {PROCEDURE_IDENTIFIERS} = procedures;

const MEP_ITEM = {
  id: PROCEDURE_IDENTIFIERS.MEP_REVISION,
  name: 'Revisión Inicial',
  _id: PROCEDURE_IDENTIFIERS.MEP_REVISION,
  code: 'MEP',
  isActive: true,
  isFinish: false,
  isSystem: false,
  deleted: false,
  order: 0,
  actor: {
    name: 'Ministerio de Economía y Planificación',
    comercialName: 'MEP',
  },
  fields
};

const COMPLETED_PROCESS = {
  id: PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS,
  name: 'Trámite Completado',
  _id: PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS,
  code: 'COMPROC',
  isActive: true,
  isFinish: true,
  isSystem: true,
  deleted: false,
  order: 0,
  actor: {
    name: 'Ministerio de Economía y Planificación',
    comercialName: 'MEP',
  }
};

function ProcessSettingsProvider(props) {
  const {
    processSettings,
    isLoadingProcessSettings,
    processKeys,
    processIds
  } = useGetProcessSettings(props?.subjectType);
  
  const sortedProcessList = useMemo(() => filter(processSettings?.configurations, (process) => process?.isActive), [processSettings]);
  
  return (
    <ProcessSettingsContext.Provider value={{
      processSettings,
      isLoadingProcessSettings,
      sortedProcessList,
      processKeys,
      processIds,
    }} {...props} />
  );
}

function useProcessSettings() {
  const context = useContext(ProcessSettingsContext);
  if (context === undefined) {
    throw new Error('usePageContent must be used within a PageContentProvider');
  }
  const {processSettings, isLoadingProcessSettings, sortedProcessList, processKeys} = context;
  
  return {processSettings, isLoadingProcessSettings, sortedProcessList: sortedProcessList || [], processKeys};
}

function useProcessSettingsProcedure() {
  const context = useContext(ProcessSettingsContext);
  if (context === undefined) {
    return {};
  }
  
  const {processSettings} = context;
  
  return {
    ...context,
    processSettings: {
      ...context.processSettings,
      configurations: [MEP_ITEM].concat(processSettings?.configurations)?.map((e, index) => ({
        ...e,
        order: index + 1
      })).concat([COMPLETED_PROCESS]),
      order: [PROCEDURE_IDENTIFIERS.MEP_REVISION].concat(processSettings?.order).concat([PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS]),
      steps: [PROCEDURE_IDENTIFIERS.MEP_REVISION].concat(processSettings?.steps).concat([PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS]),
    },
    processIds: {
      [PROCEDURE_IDENTIFIERS.MEP_REVISION]: MEP_ITEM,
      ...context.processIds,
      [PROCEDURE_IDENTIFIERS.COMPLETED_PROCESS]: COMPLETED_PROCESS
    }
  };
}

ProcessSettingsProvider.propTypes = {
  subjectType: PropTypes.string,
};

export {ProcessSettingsProvider, useProcessSettings, useProcessSettingsProcedure};
